/**
 * Worker-safe phone check: a structural E.164 test, no metadata.
 *
 * The browser keeps libphonenumber (`isValidPhone` in apps/app), which is
 * stricter: it knows each country's number lengths. The rulebook cannot carry
 * it without a runtime dependency, so here a phone must be "+", a non-zero
 * first digit and 7-15 digits in total. Spaces, dots, dashes and parentheses
 * are ignored, because stored phones carry formatting (NONRESIDENT-7P).
 */
const PHONE_SEPARATORS = /[\s().-]/g;
const E164 = /^\+[1-9]\d{6,14}$/;

export const PHONE_MESSAGE =
  "Phone number must include the country code, e.g. +1 555 123 4567";

export function isPlausiblePhone(value: string): boolean {
  if (typeof value !== "string") return false;
  return E164.test(value.replace(PHONE_SEPARATORS, ""));
}
